/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_No_Pending_ActivitiesInputs */

const en_case_no_pending_activities = /** @type {(inputs: Case_No_Pending_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pending activities`)
};

const pt_br2_case_no_pending_activities = /** @type {(inputs: Case_No_Pending_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma atividade pendente`)
};

/**
* | output |
* | --- |
* | "No pending activities" |
*
* @param {Case_No_Pending_ActivitiesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_no_pending_activities = /** @type {((inputs?: Case_No_Pending_ActivitiesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_No_Pending_ActivitiesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_no_pending_activities(inputs)
	return pt_br2_case_no_pending_activities(inputs)
});